module.exports = __webpack_public_path__ + "img/top-1-0.54753e9f.jpg";